import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { TMfaSessionIssuesFilterOptions } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { getMfaSessionIssuesFilterOptions } from 'src/apps/mfa/services/MfaSingleSessionService';
import { MFA_SESSION_FILTER_OPTIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMfaSessionFilterOptionsQuery = (
	sessionId: string
): UseQueryResult<TMfaSessionIssuesFilterOptions> => {
	const sessionDetailsQuery = useQuery([MFA_SESSION_FILTER_OPTIONS, sessionId], () =>
		getMfaSessionIssuesFilterOptions(sessionId)
	);

	return sessionDetailsQuery;
};
